import type { Configuration } from '@repo/api-gw-sdk';

import { accountLogo } from './accountLogo';
import { aiAgents } from './aiAgents';
import { apiCredentials } from './apiCredentials';
import { auditLogs } from './auditLog';
import { authV2 } from './authV2';
import { azure } from './azure';
import { backupPolicy } from './backupPolicy';
import { classificationPolicy } from './classificationPolicy';
import { cloudAccounts } from './cloudAccounts';
import { compliance } from './compliance';
import { controlPlaneConfig } from './controlPlaneConfig';
import { controls } from './controls';
import { convert } from './convert';
import { dashboards } from './dashboards';
import { db } from './db';
import { discovery } from './discovery';
import { explorer } from './explorer';
import { gcpSqlVm } from './gcpSqlVm';
import { gdsg } from './gdsg';
import { gitRepositories } from './gitRepositories';
import type { HttpClient } from './httpClient';
import { idpGroups } from './idpGroups';
import { integrations } from './integrations';
import { inventory } from './inventory';
import { jobs } from './jobs';
import { limits } from './limits';
import { logs } from './logs';
import { metering } from './metering';
import { mongoAtlasPrivateLinks } from './mongoAtlasPrivateLinks';
import { mpa } from './mpa';
import { notifications } from './notifications';
import { objectStoreExclusionRules } from './objectStoreExclusionRules';
import { organizations } from './organizations';
import { preferences } from './preferences';
import { projects } from './projects';
import { restore } from './restore';
import { restoreTemplates } from './restoreTemplates';
import { roles } from './roles';
import { saasInventory } from './saasInventory';
import { saml } from './saml';
import { savedDashboards } from './savedDashboards';
import { search } from './search';
import { security } from './security';
import { snapshotRecipes } from './snapshotRecipes';
import { stagingAccount } from './stagingAccount';
import { stagingBuckets } from './stagingBuckets';
import { storageGateway } from './storageGateway';
import { streamlake } from './streamlake';
import { threatHunting } from './threatHunting';
import { unifiedIdentityRestore } from './unifiedIdentityRestore';
import { users } from './users';
import { vaults } from './vaults';
import { zeroEtlJobs } from './zeroEtlJobs';

export const projectDalFactory = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => ({
  inventory: inventory(httpClient, config, currentProjectId),
  logs: logs(httpClient, config, currentProjectId),
  discovery: discovery(httpClient, config, currentProjectId),
  explorer: explorer(httpClient, config, currentProjectId),
  search: search(httpClient, config, currentProjectId),
  backupPolicy: backupPolicy(httpClient, config, currentProjectId),
  classificationPolicy: classificationPolicy(
    httpClient,
    config,
    currentProjectId
  ),
  jobs: jobs(httpClient, config, currentProjectId),
  zeroEtlJobs: zeroEtlJobs(httpClient, config, currentProjectId),
  restore: restore(httpClient, config, currentProjectId),
  restoreTemplates: restoreTemplates(httpClient, config, currentProjectId),
  vaults: vaults(httpClient, config, currentProjectId),
  stagingBuckets: stagingBuckets(httpClient, config, currentProjectId),
  convert: convert(httpClient, config, currentProjectId),
  db: db(httpClient, config, currentProjectId),
  dashboards: dashboards(httpClient, config, currentProjectId),
  compliance: compliance(httpClient, config, currentProjectId),
  controls: controls(httpClient, config, currentProjectId),
  cloudAccounts: cloudAccounts(httpClient, config, currentProjectId),
  mongoAtlasPrivateLinks: mongoAtlasPrivateLinks(
    httpClient,
    config,
    currentProjectId
  ),
  azure: azure(httpClient, config, currentProjectId),
  gcpSqlVm: gcpSqlVm(httpClient, config, currentProjectId),
  mpa: mpa(httpClient, config, currentProjectId),
  notifications: notifications(httpClient, config, currentProjectId),
  integrations: integrations(httpClient, config, currentProjectId),
  security: security(httpClient, config, currentProjectId),
  snapshotRecipes: snapshotRecipes(httpClient, config, currentProjectId),
  threatHunting: threatHunting(httpClient, config, currentProjectId),
  storageGateway: storageGateway(httpClient, config, currentProjectId),
  gdsg: gdsg(httpClient, config, currentProjectId),
  streamlake: streamlake(httpClient, currentProjectId),
  unifiedIdentityRestore: unifiedIdentityRestore(
    httpClient,
    config,
    currentProjectId
  ),
  gitRepositories: gitRepositories(httpClient, config, currentProjectId),
  limits: limits(httpClient, config, currentProjectId),
  objectStoreExclusionRules: objectStoreExclusionRules(
    httpClient,
    config,
    currentProjectId
  ),
  metering: metering(httpClient, config),
  saasInventory: saasInventory(httpClient, config, currentProjectId),
});

export const nonProjectDalFactory = (
  httpClient: HttpClient,
  config: Configuration,
  isDevOrTest: boolean
) => ({
  auditLogs: auditLogs(httpClient, config),
  authV2: authV2(httpClient, config),
  projects: projects(httpClient, config),
  users: users(httpClient, config, isDevOrTest),
  preferences: preferences(httpClient, config),
  saml: saml(httpClient, config),
  idpGroups: idpGroups(httpClient, config),
  organizations: organizations(httpClient, config),
  roles: roles(httpClient, config),
  apiCredentials: apiCredentials(httpClient, config, isDevOrTest),
  aiAgents: aiAgents(httpClient, config),
  controlPlaneConfig: controlPlaneConfig(httpClient, config),
  accountLogo: accountLogo(httpClient, config),
  stagingAccount: stagingAccount(httpClient, config),
  savedDashboards: savedDashboards(httpClient, config),
});
